import { render, staticRenderFns } from "./PieChartLegend.vue?vue&type=template&id=74dd6783&"
import script from "./PieChartLegend.vue?vue&type=script&lang=js&"
export * from "./PieChartLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports